import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import { Icon } from "../../ui";
import "./collaborations.css";

const CollaborationsPage = lazy(() => import("./list").then((m) => ({ default: m.CollaborationsPage })));
const CollabPage = lazy(() => import("./collab").then((m) => ({ default: m.CollabPage })));
const CollaborationsSettings = lazy(() => import("./settings").then((m) => ({ default: m.CollaborationsSettings })));

/** Collaborations: the list, and each collaboration's page with its tabs (?tab=). */

export const routes: SolutionRoute[] = [
  { solution: "collaborations", path: "collaborations", element: <CollaborationsPage /> },
  { solution: "collaborations", path: "collaborations/:id", element: <CollabPage /> },
];

export const settings: SolutionSettings[] = [{ solution: "collaborations", key: "collaborations", label: "Collaborations", icon: Icon.share, need: "collaborations.view", Component: CollaborationsSettings }];
